import React, { useContext } from "react";
import embLabels from "../../config/emb-labels-en.json";
import ACTIONS from "./Design_Asset_Actions.json";
import isTouchDevice from "../SE-Component/Tooltip";

import { AssetBlockContext } from "../CustomHooks/ContextApi";

const PVAsset = () => {
  const {
    PVDetails,
    selectedValues,
    PVDetailsDispatch,
    assetEditStatusUpdatePv,
    updatePvArrayConfig,
    selectedAssetHandlerPv,
    removePvWithAlert,
    removePv,
    isCopyAllButtonDisabled,
    copyAllPvs,
    arrayMaxPowerFinder,
  } = useContext(AssetBlockContext);

  const pvArrayChangeHandler = e => {
    PVDetailsDispatch({
      type: ACTIONS.CONFIGURE_PV_ARRAY,
      payload: {
        data: e.target,
      },
    });

    assetEditStatusUpdatePv(
      e,
      true,
      PVDetails.selectedPv,
      PVDetails.selectSubPv
    );
  };

  const onChangePvSubSelectionHandler = selectSubPv => {
    PVDetailsDispatch({
      type: ACTIONS.INDIVIDUAL_PV_SELECT,
      payload: {
        selectSubPv: selectSubPv,
        selectedPv: selectedValues.selectedPv,
      },
    });
    selectedAssetHandlerPv(selectedValues.selectedPv, selectSubPv);
  };

  return (
    <div name="pv" className="col-md-12 p-0">
      <div className="col-md-12 pt-2 pl-0 se-white-background">
        <div className="col-md-12 pb-2  se-white-background">
          <se-icon
            color="primary"
            className="se-icon icon_button se-life-green"
            size="medium"
          >
            solar_panel1
          </se-icon>
          <span className="ml-2 bold">PhotoVoltaic</span>
          <span className="float-right">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={removePv}
            >
              Remove
            </button>
          </span>
        </div>
      </div>

      <div className=" col-md-12 dropdown-divider"></div>

      <div className="col-md-12">
        <div className="row">
          <label className=" col-md-6 bold mt-1 se-font-14px">
            Configure PV Array
          </label>
          <div className="col-md-6 mt-1 mb-1 text-right">
            <button
              type="button"
              className="btn btn-secondary btn-sm se-btn-primary"
              onClick={updatePvArrayConfig}
            >
              <se-icon size="nano">action_save</se-icon>
              <span>&nbsp;</span>Save
            </button>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="exampleFormControlInput1">
            Name <span className="se-mandatory">*</span>
          </label>
          <input
            type="text"
            autoComplete="none"
            id="exampleFormControlInput1"
            className={"form-control form-control-sm "}
            name="groupName"
            placeholder="Group Name"
            value={PVDetails.pvConfig.groupName}
            onChange={pvArrayChangeHandler}
          />
          <div
            className="invalid-feedback-custom"
            style={
              PVDetails.pvConfig.groupName === "" ? {} : { display: "none" }
            }
          >
            {embLabels.nameRequired}
          </div>
        </div>
        <div className="form-group mb-1">
          <label htmlFor="exampleFormControlInput1">
            Array Max Power (kWp) <span className="se-mandatory">*</span>
          </label>
          <se-tooltip
            action={isTouchDevice() ? "click" : "hover"}
            position="left"
          >
            <se-icon
              option="raised"
              color="secondary"
              size="small"
              slot="tooltip"
            >
              information_circle
            </se-icon>
            <se-tooltip-content>
              Sum of all PV inverter max power.
            </se-tooltip-content>
          </se-tooltip>
          <input
            type="text"
            autoComplete="none"
            className={"form-control form-control-sm "}
            id="exampleFormControlInput1"
            placeholder="Array Max Power (kWp)"
            maxLength="5"
            name="group_max_power"
            value={PVDetails.pvConfig.group_max_power}
            onChange={pvArrayChangeHandler}
          />
          <div
            className="invalid-feedback-custom"
            style={
              !(parseInt(PVDetails.pvConfig.group_max_power) >= 0)
                ? {}
                : { display: "none" }
            }
          >
            Array Max Power(kWp) is required.
          </div>
          <div
            className="invalid-feedback-custom"
            style={
              PVDetails.pvConfig.group_max_power === "" ||
              parseInt(PVDetails.pvConfig.group_max_power) <=
                arrayMaxPowerFinder()
                ? { display: "none" }
                : {}
            }
          >
            Array Max Power should not exceed sum of all PV inverter max power.
          </div>
        </div>
        <div className=" col-md-12 dropdown-divider"></div>

        <div className="row form-group mt-2 mb-0">
          <label className=" col-md-6 bold mt-1 se-font-14px">
            Configure PV inverters{" "}
          </label>
          <div className="col-md-6 mt-1 mb-1 text-right">
            <button
              type="button"
              className="btn btn-secondary btn-sm se-btn-primary"
              disabled={
                isCopyAllButtonDisabled(PVDetails.selectedPv) ? "" : "disabled"
              }
              onClick={copyAllPvs}
            >
              <se-icon size="nano">action_saveas</se-icon>
              <span>&nbsp;</span>Copy All
            </button>
          </div>
        </div>
        <div className="form-group mb-1">
          <label
            className={
              parseInt(PVDetails.pvConfiguredCountInCB) ===
              parseInt(PVDetails.pvCountInCB)
                ? "se-life-green"
                : "se-warning"
            }
          >
            <se-icon color="primary" size="nano">
              information_circle
            </se-icon>
            Configured {PVDetails.pvConfiguredCountInCB} PV out of{" "}
            {PVDetails.pvCountInCB} PV{" "}
          </label>
        </div>

        {parseInt(selectedValues.selectedPv) === 3 &&
          PVDetails.pvset1Data.map((data, index) => (
            <div
              className={
                (PVDetails.selectSubPv === index + 1 &&
                PVDetails.displayPvContent
                  ? "selected-asset"
                  : data.status === false
                  ? "unconfigured"
                  : "") + " col-md-12  p-0"
              }
              key={data.name}
            >
              <div className="se-chip col-md-11 text-left">
                <se-icon
                  size="small"
                  color="primary"
                  className="icon-small hydrated"
                >
                  solar_panel1
                </se-icon>
                <div
                  className="align-top line-height-25 pointer d-inline-block displayPvChipName "
                  onClick={() => onChangePvSubSelectionHandler(index + 1)}
                >
                  {data.name}
                </div>
                <span
                  className="pointer"
                  onClick={() => removePvWithAlert(index + 1)}
                >
                  <se-icon size="small" className="icon-small hydrated">
                    notification_error_plain
                  </se-icon>
                </span>
              </div>
            </div>
          ))}

        {parseInt(selectedValues.selectedPv) === 4 &&
          PVDetails.pvset2Data.map((data, index) => (
            <div
              className={
                (PVDetails.selectSubPv === index + 1 &&
                PVDetails.displayPvContent
                  ? "selected-asset"
                  : data.status === false
                  ? "unconfigured"
                  : "") + " col-md-12  p-0"
              }
              key={data.name}
            >
              <div className="se-chip col-md-11 text-left">
                <se-icon
                  size="small"
                  color="primary"
                  className="icon-small hydrated"
                >
                  solar_panel1
                </se-icon>
                <div
                  className="align-top line-height-25 pointer d-inline-block displayPvChipName "
                  onClick={() => onChangePvSubSelectionHandler(index + 1)}
                >
                  {data.name}
                </div>
                <span
                  className="pointer"
                  onClick={() => removePvWithAlert(index + 1)}
                >
                  <se-icon size="small" className="icon-small hydrated">
                    notification_error_plain
                  </se-icon>
                </span>
              </div>
            </div>
          ))}

        {parseInt(selectedValues.selectedPv) === 5 &&
          PVDetails.pvset3Data.map((data, index) => (
            <div
              className={
                (PVDetails.selectSubPv === index + 1 &&
                PVDetails.displayPvContent
                  ? "selected-asset"
                  : data.status === false
                  ? "unconfigured"
                  : "") + " col-md-12  p-0"
              }
              key={data.name}
            >
              <div className="se-chip col-md-11 text-left">
                <se-icon
                  size="small"
                  color="primary"
                  className="icon-small hydrated"
                >
                  solar_panel1
                </se-icon>
                <div
                  className="align-top line-height-25 pointer d-inline-block displayPvChipName "
                  onClick={() => onChangePvSubSelectionHandler(index + 1)}
                >
                  {data.name}
                </div>
                <span
                  className="pointer"
                  onClick={() => removePvWithAlert(index + 1)}
                >
                  <se-icon size="small" className="icon-small hydrated">
                    notification_error_plain
                  </se-icon>
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PVAsset;
